import { useEffect, useContext, useState } from 'react';
import useFetch, { CachePolicies } from 'use-http';

import { API_ROUTES } from '../../constants';
import { AuthContext } from '@marketplace/common';

import { TApplicationsResponse } from '../../applications';
import { FetchDeveloperApplicationsParams, TAPIFetchDeveloperApplications } from './applications.types';

export const useAPIFetchDevelopersApplications =
  (): TAPIFetchDeveloperApplications => {
    const [hasUnknownUserOrPurpose, sethasUnknownUserOrPurpose] = useState<boolean>(false);
    const [applications, setApplications] = useState<TApplicationsResponse | null>(null);
    const { get, response, error, loading } = useFetch(
      API_ROUTES.DEVELOPERS,
      {
        cachePolicy: CachePolicies.NO_CACHE,
      }
    );
    const { developerContext } = useContext(AuthContext);

    const fetchDevelopersApplications = async (
      params: FetchDeveloperApplicationsParams = {}
    ): Promise<void> => {
      const defaultParams = {
        per_page: '10',
        page: '1',
      };
      if (!params.per_page || !params.page) {
        params = defaultParams;
      }
      const queryParams = new URLSearchParams(
        Object.entries(params).reduce((acc, [key, value]) => {
          if (value !== undefined && value !== null) {
            acc[key] = String(value);
          }
          return acc;
        }, {} as Record<string, string>)
      );
    
      const url = `/${developerContext?.id}/applications?${queryParams.toString()}`;
      const { data } = await get(url);
      if (data?.items) {
        setApplications(data);
      } else {
        setApplications(null);
      }
    };
      const fetchDevelopersApplicationsWithUnknowUserPurpose = 
      async (): Promise<void> => {
       
        const data = await get(`/${developerContext?.id}/application-user-purpose-check`) ;
        sethasUnknownUserOrPurpose(!!data?.data?.hasUnknownUserAndPurpose) 
      };
    useEffect(() => {
      if (developerContext?.id) { 
        fetchDevelopersApplicationsWithUnknowUserPurpose();
        fetchDevelopersApplications();
      }
    }, [developerContext?.id]);
    return {
      data: applications ,
      loading,
      error,
      loaded: response.ok,
      fetchDevelopersApplicationsWithUnknowUserPurpose ,
      fetchDevelopersApplications,
      isUnknown : hasUnknownUserOrPurpose
    };
  };
